<template>
	<div class="particular">
		<div class="title">
			订单详情
		</div>
		<div class="orderStatus">
			订单状态：<span>{{auctionStatus == 4 ? '流拍' : (status == 1 ? '已支付' : '未支付')}}</span>
		</div>
		<div class="commodity">
			<div class="image">
				<el-image style="width: 100%; height: 100%;" :src="$pub.imageUrl+info.image" fit="scale-down"
					:preview-src-list="[$pub.imageUrl+info.image]">
				</el-image>
			</div>
			<div class="right">
				<div class="name">
					{{info.name}}
				</div>
				<div class="author">
					作者/权属人：{{info.author}}
				</div>
				<div class="price">
					成交价：<span>¥{{info.price}}</span>
				</div>
				<div class="number">
					<!-- 数量：<i class="el-icon-close"></i>{{info.number}} -->
				</div>
			</div>
		</div>
		<div class="line">
			<div class="key">订单编号：</div>
			<div class="value">{{info.series}}</div>
		</div>
		<div class="line">
			<div class="key">下单时间：</div>
			<div class="value">{{info.time}}</div>
		</div>
		<div class="line" v-if="status == 1">
			<div class="key">支付方式：</div>
			<div class="value">{{info.payment}}</div>
		</div>
		<div class="line" v-if="status == 1">
			<div class="key">支付时间：</div>
			<div class="value">{{info.payTime}}</div>
		</div>
		<div class="line">
			<div class="key">实付金额：</div>
			<div class="value"><span>¥{{info.money}}</span></div>
		</div>
		<div class="line" v-if="auctionStatus!=4">
			<div class="key">提示：</div>
			<div class="value">
				<span class="hint" v-if="deposit == 0">保证金用于抵扣支付金额。</span>
				<span class="hint" v-if="deposit == 1">保证金在支付后释放。</span>
			</div>
		</div>
		<div class="payButton">
			<el-button type="danger" size="medium" round @click="goPay" v-if="status!=1 && auctionStatus != '4'">去支付
			</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'particular',
		data() {
			return {
				id: '',
				lotId: '',
				info: {
					image: '',
					name: '',
					author: '',
					price: 0,
					number: 0,
					series: '',
					time: '',
					payment: '',
					payTime: '',
					money: ''
				},
				status: 0,
				deposit: '',
				auctionStatus: ''
			};
		},
		methods: {
			fetchData() {
				this.$api.frontOrderDetail({
					lotOrderId: this.id,
					userId: this.$store.state.userinfo.userId
				}, res => {
					if (res.code == 200) {
						this.info['series'] = res.data.lotOrderId
						this.info['time'] = res.data.createAt
						this.info['payTime'] = res.data.payTime
						this.info['money'] = res.data.payPrice
						this.info['payment'] = res.data.channel == '1' ? '微信' : '支付宝'
						this.info['price'] = res.data.endPrice
						this.status = res.data.payStatus
					}
				})
			},
			fetchAuctionDetail() {
				this.$api.frontAutionDetail({
					id: this.lotId,
				}, res => {
					if (res.code == 200) {
						this.info['image'] = res.data.lotPictrueUrl
						this.info['name'] = res.data.lotName
						this.info['author'] = res.data.lotAuthor
						this.deposit = res.data.bondType
						this.auctionStatus = res.data.auctionStatus
					}
				})
			},
			goPay() {
				this.$router.push({
					path: '/payment',
					query: {
						order: this.id,
						type: 2
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.id = this.$route.query.id
			this.lotId = this.$route.query.lotId
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
			this.fetchAuctionDetail()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.particular {
		width: 100%;

		.title {
			width: 100%;
			height: 50px;
			display: flex;
			align-items: center;
			font-size: @vue-font-size-base;
			border-bottom: 2px solid @vue-border-color-red;
			box-sizing: border-box;
		}

		.orderStatus {
			width: 100%;
			height: 60px;
			display: flex;
			align-items: center;
			font-size: @vue-font-size-base;
			color: @vue-text-color-red;
		}

		.commodity {
			width: 100%;
			height: 200px;
			display: flex;
			margin-top: @vue-spacing-col-lg;
			margin-bottom: @vue-spacing-col-lg;

			.image {
				width: 250px;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.right {
				width: calc(100% - 250px);
				height: 100%;
				padding-left: @vue-spacing-row-base;
				box-sizing: border-box;

				.name {
					width: 100%;
					padding: 10px 0px;
					line-height: 30px;
					font-size: @vue-font-size-sm + 2;
					font-weight: bold;
				}

				.author,
				.price,
				.number {
					width: 100%;
					height: 36px;
					display: flex;
					align-items: center;

					span {
						color: @vue-text-color-red;
					}
				}
			}
		}

		.line {
			width: 100%;
			height: 50px;
			border-bottom: 1px dashed @vue-border-color;
			display: flex;
			align-items: center;

			.key,
			.value {
				height: 100%;
				display: flex;
				align-items: center;
				line-height: 50px;
			}

			.key {
				width: 100px;
				justify-content: flex-end;
			}

			.value {
				span {
					color: @vue-text-color-red;
				}
			}
		}

		.payButton {
			width: 100%;
			height: 150px;
			display: flex;
			justify-content: center;
			align-items: flex-start;
			padding-top: @vue-spacing-col-lg*2;
			box-sizing: border-box;

			.el-button {
				width: 180px;
			}
		}
	}

	.hint {
		font-size: @vue-font-size-min + 2;
	}
</style>
